import { registerComponent } from '@gig/magic-common';
import corexUserDetailsComponent from './user-details.vue.js';

var corexUserDetails = registerComponent(corexUserDetailsComponent);

export { corexUserDetails };
